import { render, staticRenderFns } from "./ControlloAlloggiOspitiIdView.vue?vue&type=template&id=d197ada2&"
import script from "./ControlloAlloggiOspitiIdView.vue?vue&type=script&lang=ts&"
export * from "./ControlloAlloggiOspitiIdView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports